







import Vue from 'vue'
import AnonimousLayout from '@/layouts/Anonimous.layout.vue'

export default Vue.extend({
    name: 'ContainerLogin',
    components: {
      // Incluimos el layout que utilizará este módulo
      // Layout
      AnonimousLayout
    },
})
